const waitForElement = (selector, callback) => {
	var interval = setInterval(function () {
		if (window.$(selector).length) {
			clearInterval(interval);  // Stop checking once the element is found
			callback();  // Execute callback
		}
	}, 100);  // Check every 100ms
}

export default waitForElement